<footer>
    <p>&copy; Copyright 2021. All rights reserved.</p>
</footer>